import { memo } from 'react'

import CreateFinalAfterInactivity, {
  InactivityType
} from './containers/CreateFinalAfterInactivity'
import { useRootStore } from 'stores/utils/hooks/useRootStore'
import { getAge } from 'utils/date'
import {
  determineTimeout,
  TIMEOUT_FIVE_MINUTES,
  TIMEOUT_TWO_MINUTES
} from 'InactivityContainer.helpers'
import { PossibleVariants } from 'utils/tracking/optimizely/types'
import { Experiments } from 'CustomOptimizelyProvider'
import { getAgeGroupFromAge } from 'stores/helpers/AgeGroups'
import { AgeGroup } from 'constants/components'
import { isPremiumCustomer } from 'utils/user'

type InactivityProps = {
  handleSubmit: () => void
  isSmava?: boolean
}

const InactivityContainer = ({ handleSubmit, isSmava }: InactivityProps) => {
  const {
    rootStore: {
      experimentData,
      traversal: {
        data: {
          common: { amount },
          debtors: {
            primary: {
              personal: { birthday },
              income
            }
          }
        }
      }
    }
  } = useRootStore()

  const debtorsAge = getAge(birthday)

  const ageGroup = getAgeGroupFromAge(debtorsAge)

  const isPremium = isPremiumCustomer({ debtorsAge, amount, income })

  const isInSkipDacV3Experiment =
    // @ts-ignore - experimentData type needs refinement for dynamic access
    experimentData[Experiments.CAT_4359_DAC_SKIP_BUTTON_V3] ===
      PossibleVariants.VARIATION_B ||
    // @ts-ignore - experimentData type needs refinement for dynamic access
    experimentData[Experiments.CAT_4359_DAC_SKIP_BUTTON_V3] ===
      PossibleVariants.VARIATION_C

  const isIn4463Experiment =
    experimentData[Experiments.CAT_4463_RCE_DAC_SKIP_BUTTON_ACCEPTED] ===
      PossibleVariants.VARIATION_B ||
    experimentData[Experiments.CAT_4463_RCE_DAC_SKIP_BUTTON_SALABLE] ===
      PossibleVariants.VARIATION_B

  let timeout = determineTimeout(debtorsAge, isSmava || false)

  if (ageGroup === AgeGroup.OLD_AGE_GROUP && isInSkipDacV3Experiment) {
    timeout = TIMEOUT_TWO_MINUTES
  }

  if (
    isIn4463Experiment &&
    (ageGroup === AgeGroup.OLD_AGE_GROUP || isPremium)
  ) {
    timeout = TIMEOUT_TWO_MINUTES
  }

  if (!timeout) {
    return null
  }

  return (
    <>
      <CreateFinalAfterInactivity
        timeout={TIMEOUT_FIVE_MINUTES}
        inactivityType={InactivityType.PAYOUT_ACCOUNT_INACTIVITY}
        onNext={handleSubmit}
      />
      <CreateFinalAfterInactivity
        timeout={timeout}
        inactivityType={InactivityType.DAC_INACTIVITY}
        onNext={handleSubmit}
      />
    </>
  )
}

export default memo(InactivityContainer)
